'use client'

import { Icon } from 'shared/iconpack'
import { clsx } from 'shared/libs/style-merge'
import { QueryParams } from 'shared/types/QueryModel'

import { Image } from 'shared/ui'
import { Button } from 'shared/ui/button'

import { RouterPath } from 'shared/config/routerPath/RouterPath'
import { globalStyles } from 'shared/config/styles/globalStyles'

import styles from './CategoryLinkCard.module.scss'

interface CategoryLinkCardProps {
  title: string
  subtitle?: string
  id: number | string
  icon: string
  className?: string
  isDiscount?: boolean
  link?: string
  imageSize?: number
}

const discountLimit = 18

export function CategoryLinkCard({
  icon,
  subtitle,
  id,
  title,
  className,
  isDiscount = false,
  link,
  imageSize = 20,
}: CategoryLinkCardProps) {
  const href = isDiscount
    ? `${RouterPath.CATALOG}/?${QueryParams.DISCOUNT}=true&${QueryParams.LIMIT}=${discountLimit}`
    : `${RouterPath.CATEGORY}/${id}`

  return (
    <Button
      href={link || href}
      className={clsx(styles.linkButton, className)}
      variant="supportive"
      replace
      rightIcon={<Icon name="chevronRight" />}
    >
      <div className={styles.label}>
        <Image src={icon} alt="icon" width={imageSize} height={imageSize} />
        <div className={styles.text}>
          <span className={styles.title}>{title}</span>
          {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
        </div>
        <Icon
          name="chevronRight"
          size={12}
          color={globalStyles['--icon-primary']}
        />
      </div>
    </Button>
  )
}
